import { Box } from "@mui/material";

const ZodiacDailyHoroscope = () => {
  return <Box>ZodiacDailyHoroscope</Box>;
};
export default ZodiacDailyHoroscope;
